import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';

// Styles
import './styles/form-error-composer.scss';

const createWrapper = (Comp) =>
    class FormError extends PureComponent {
        static defaultProps = {};

        static propTypes = {
            contextCls: PropTypes.string,
            id: PropTypes.string,
            errorText: PropTypes.string,
            errorIconCls: PropTypes.string,
            iconCls: PropTypes.string,
            renderCustomError: PropTypes.func,
        };

        render() {
            const { contextCls, errorText, renderCustomError } = this.props;

            return (
                <Fragment>
                    {this.renderComp()}
                    {errorText && (
                        <span className={cx(`${this.baseCls}`, contextCls)}>
                            {renderCustomError
                                ? this.renderCustomError()
                                : this.renderDefaultError()}
                        </span>
                    )}
                </Fragment>
            );
        }

        renderDefaultError = () => {
            const { iconCls, errorIconCls, errorText } = this.props;

            return (
                <Fragment>
                    {(errorIconCls || iconCls) && (
                        <span
                            className={`${this.baseCls}__icon ${
                                errorIconCls || iconCls
                            }`}
                        />
                    )}{' '}
                    <span className={`${this.baseCls}__text`}>{errorText}</span>
                </Fragment>
            );
        };

        renderCustomError = () => {
            const {
                renderCustomError,
                errorText,
                iconCls,
                errorIconCls,
            } = this.props;
            const errorProps = {
                baseCls: this.baseCls,
                errorIconCls,
                errorText,
                iconCls,
            };

            return renderCustomError(errorProps);
        };

        renderComp() {
            const { id, errorText } = this.props;
            const compProps = { ...this.props, id: id || this.id };
            delete compProps.contextCls;
            delete compProps.errorText;
            delete compProps.iconCls;
            delete compProps.errorIconCls;
            delete compProps.renderCustomError;

            if (errorText) {
                delete compProps.hintText;
            }

            return <Comp {...compProps} hasError={!!errorText} />;
        }

        baseCls = 'fluid-form-error';

        id = `fluid-form-el-${uuidv4()}`;
    };

const FormErrorComposer = createWrapper;

export default FormErrorComposer;
